.button {
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-family: inherit;
  text-transform: none;
  border-radius: 3px;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border 0.2s ease;
  padding: 6px 12px;
  gap: 6px;
  color: var(--main-text);
}

/* Size variants */
.small {
  font-size: 12px;
  padding: 4px 8px;
}
.small .icon {
  font-size: 16px;
}
.default {
  font-size: 14px;
  padding: 6px 12px;
}
.default .icon {
  font-size: 18px;
}
.large {
  font-size: 16px;
  padding: 8px 16px;
}

/* --- Intent base text color (for icons too) --- */
.primary,
.success,
.warning,
.danger {
  color: white;
}

/* Filled (default) variant */
.filled.primary {
  background-color: var(--button-primary-color);
}

.filled.primary:hover,
.filled.primary:active,
.filled.primary:focus {
  background-color: var(--button-primary-pseudo-color);
}

/* .filled.success {
  background-color: var(--button-success-color)
}
.filled.success:hover,
.filled.success:active,
.filled.success:focus  {
  background-color: var(--button-success-pseudo-color)
}

.filled.warning {
  background-color: #bf7326;
}
.filled.warning:hover {
  background-color: #d9822b;
}
.filled.danger {
  background-color: #c23030;
}
.filled.danger:hover {
  background-color: #db3737;
} */

/* Outlined variant */
.outlined {
  background-color: transparent;
  border: 1px solid currentColor;
}

.outlined.primary,
.outlined.primary .icon {
  color: var(--button-primary-color);
}

.outlined.primary:hover,
.outlined.primary:active,
.outlined.primary:focus {
  background-color: var(--button-minimal-primary-color);
}

/* .outlined.success, .outlined.success .icon  {
  color: var(--button-success-color);
}
.outlined.warning, .outlined.warning .icon {
  color: #bf7326;
}
.outlined.danger, .outlined.danger .icon {
  color: #c23030;
} */

/* Minimal variant */
.minimal {
  background-color: transparent;
}
.minimal.primary {
  background-color: var(--button-minimal-primary-color);
}

.minimal.primary,
.minimal.primary .icon {
  color: var(--button-primary-color);
}
.minimal.primary:hover,
.minimal.primary:active,
.minimal.primary:focus {
  background-color: var(--button-minimal-primary-pseudo-color);
}

/* .minimal.success {
  background-color: rgba(10, 102, 64, 0.1);
}

.minimal.success, .minimal.success .icon {
  color: #0a6640;
}

.minimal.success:hover {
  background-color: rgba(10, 102, 64, 0.2);
}
.minimal.warning {
  background-color: rgba(191, 115, 38, 0.1);
}
.minimal.warning, .minimal.warning .icon {
  color: #bf7326;
}
.minimal.warning:hover {
  background-color: rgba(191, 115, 38, 0.2);
}
.minimal.danger {
  background-color: rgba(194, 48, 48, 0.1);
}
.minimal.danger, .minimal.danger .icon {
  color: #c23030;
}
.minimal.danger:hover {
  background-color: rgba(194, 48, 48, 0.2);
} */

.text {
  background-color: transparent;
  border: none;
  padding-right: 12px;
  padding-left: 12px;
}

.text.primary,
.text.primary .icon {
  color: var(--button-primary-color);
}
.text:hover,
.text:active,
.text:focus {
  background-color: var(--main-background);
}

.text.primary:hover,
.text.primary:active,
.text.primary:focus {
  background-color: var(--button-minimal-primary-color);
}

/* .text.success, .text.success .icon {
  color: #0a6640;
}
.text.success:hover {
  background-color: rgba(10, 102, 64, 0.1);
}

.text.warning, .text.warning .icon {
  color: #bf7326;
}
.text.warning:hover {
  background-color: rgba(191, 115, 38, 0.1);
}

.text.danger, .text.danger .icon {
  color: #c23030;
}
.text.danger:hover {
  background-color: rgba(194, 48, 48, 0.1);
} */

/* Icon layout */
.icon {
  display: flex;
}

/* Loading */
.loading {
  opacity: 0.7;
  pointer-events: none;
}

/* Rounded */
.rounded {
  border-radius: 20px;
}
